//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "KhoranaRiskScore",
  data() {
    return {
      form: {
        primaryTumorSite: "",
        platelet: "0",
        hemoglobin: "0",
        wbc: "0",
        bmi: "0",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "2", name: "极高危：胃、胰腺" },
        { value: "1", name: "高危：肺、淋巴瘤、妇科肿瘤、膀胱、睾丸" },
        { value: "0", name: "其他部位" },
      ],
      
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/KhoranaRiskScore.vue